import { Autocomplete, Box, Button, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Paper, Radio, RadioGroup, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { isEmpty, OfferType, printDebugLog, RESYMBOL, StayType } from "../../constants/Constants";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from '@mui/icons-material/Delete';

// listBanquetHall = { listBanquetHall }
// stayType = { billInformation?.stayType }
// totalDaysStay = { billInformation?.totalDaysStay || 1}
// totalBanquetBookingDetails = { totalBanquetBookingDetails }
// setTotalBanquetBookingDetails = { setTotalBanquetBookingDetails }
// setBillPayInfo = { setBillPayInfo }
// setColumns = { setColumns }
// initialBanquetInformation = { banquetInformation }
const BanquetForm = ({
    stayType,
    totalDaysStay,
    listBanquetHall,
    totalBanquetBookingDetails,
    initialBanquetInformation,
    setTotalBanquetBookingDetails,
    billPayInfo,
    setBillPayInfo,
    setSnpComponent,
    disabledOperation }) => {

    const [isEdit, setIsEdit] = useState(false);
    const [banquetData, setBanquetData] = useState(totalBanquetBookingDetails?.items[0] || null);
    const [banquetInformation, setBanquetInformation] = useState(initialBanquetInformation || null);
    const canSelectRate = stayType !== -1 && totalDaysStay > 0;



    useEffect(() => {
        printDebugLog("BanquetForm billPayInfo", billPayInfo)
    }, [billPayInfo]);


    function upsertBanquetItem(itemData) {
        if (!itemData || itemData.id == null) {
            console.warn("upsertBanquetItem: itemData.id is required");
            return;
        }

        setTotalBanquetBookingDetails(prev => {
            const items = [...prev.items];
            const idx = items.findIndex(it => String(it.id) === String(itemData.id));

            if (idx >= 0) {
                items[idx] = { ...items[idx], ...itemData };
                return {
                    ...prev,
                    items,
                    added: items.length > 0,
                };
            } else {
                items.push(itemData);
                return {
                    ...prev,
                    items,
                    totalSize: prev.totalSize + 1,
                    added: true,
                };
            }
        });
    }

    function deleteBanquetItem(id) {
        setTotalBanquetBookingDetails(prev => {
            const nextItems = prev.items.filter(it => String(it.id) !== String(id));
            const removed = nextItems.length !== prev.items.length;

            return {
                ...prev,
                items: nextItems,
                totalSize: removed ? Math.max(0, prev.totalSize - 1) : prev.totalSize,
                added: nextItems.length > 0 ? prev.added : false,
            };
        });
    }

    const doTotal = (mTotalBanquetPrice) => {
        printDebugLog("doTotal", mTotalBanquetPrice, billPayInfo);
        let mCgstAmt = 0.0;
        let mSgstAmt = 0.0;
        let mRoundOff = 0.0;
        let mSubTotal = 0.0;
        let mFinalPrice = 0.0;
        const parseCgst = Number(billPayInfo?.cgst ?? 0) / 100;
        const parseSgst = Number(billPayInfo?.sgst ?? 0) / 100;
        const parseOfferDenom = Number(billPayInfo?.takenDenom ?? OfferType.No_Offer);
        const parseOfferAmt = Number(billPayInfo?.takenOffrAmt ?? 0);

        const restoNExtraTotalPrice = Number(billPayInfo?.totalExtraPrice ?? 0) + Number(billPayInfo?.totalRestaurantBillPrice ?? 0);

        mSubTotal = mTotalBanquetPrice + Number(billPayInfo?.totalRoomPrice ?? 0);

        mSubTotal = (mSubTotal * totalDaysStay) + restoNExtraTotalPrice;
        mFinalPrice = mSubTotal;
        if (parseOfferDenom === OfferType.Flat) {
            mFinalPrice -= parseOfferAmt;
        } else if (parseOfferDenom === OfferType.Percentage) {
            mFinalPrice -= (mFinalPrice * parseOfferAmt / 100);
        }
        if (billPayInfo?.gstAllowed ?? true) {
            mCgstAmt = (mFinalPrice * parseCgst);
            mSgstAmt = (mFinalPrice * parseSgst);
        }
        mFinalPrice = mFinalPrice + mCgstAmt + mSgstAmt;
        mRoundOff = mFinalPrice.toFixed() - mFinalPrice;
        mFinalPrice = mFinalPrice + mRoundOff;
        const pendingAmt = billPayInfo?.paymentInitiated ?? false ? billPayInfo?.pendingAmt ?? 0 : mFinalPrice;

        setBillPayInfo(prev => ({
            ...prev,
            totalBanquetPrice: mTotalBanquetPrice,
            cgstAmt: mCgstAmt,
            sgstAmt: mSgstAmt,
            roundOff: mRoundOff,
            totalPrice: mSubTotal,
            finalPrice: mFinalPrice,
            pendingAmt: pendingAmt,
        }));
    }

    const updateData = () => {
        printDebugLog("updateData", banquetData);
        if (banquetData) {
            let oldPrice = 0.0;
            const oldIndex = totalBanquetBookingDetails.items.findIndex(item => item.id === banquetData.id);
            if (oldIndex !== -1) {
                oldPrice = totalBanquetBookingDetails.items[oldIndex].sAmt || 0;
            }

            const mTotalBanquetPrice = Number(billPayInfo?.totalBanquetPrice ?? 0) + Number(banquetData?.sAmt ?? 0) - oldPrice;
            doTotal(mTotalBanquetPrice);

            upsertBanquetItem(banquetData);

            setBanquetData(null);
            setBanquetInformation(null);
            setSnpComponent(prev => ({
                ...prev,
                snackBarOpen: true,
                snackBarMsg: `${isEdit ? "Updated" : "Created"} Successfully`,
            }))
            setIsEdit(false);
        } else {
            setSnpComponent(prev => ({
                ...prev,
                snackBarOpen: true,
                snackBarMsg: "Please select rate card",
            }))
        }
    }

    const deleteCurrentBanquet = (banquetData) => {
        printDebugLog("deleteCurrentBanquet", banquetData);
        if (disabledOperation) {
            setSnpComponent(prev => ({
                ...prev,
                snackBarOpen: true,
                snackBarMsg: "Cancelled bill cannot be deleted",
            }));
            return;
        }
        if (billPayInfo?.paymentInitiated ?? false) {
            setSnpComponent(prev => ({
                ...prev,
                snackBarOpen: true,
                snackBarMsg: "Paid bill cannot be edited",
            }));
            return;
        }
        const mTotalBanquetPrice = Number(billPayInfo?.totalBanquetPrice ?? 0) - Number(banquetData?.sAmt ?? 0);
        doTotal(mTotalBanquetPrice);
        deleteBanquetItem(banquetData?.id);
        setBanquetData(null);
        setBanquetInformation(null);
        setSnpComponent(prev => ({
            ...prev,
            snackBarOpen: true,
            snackBarMsg: `Deleted Successfully`,
        }))
    }

    const handleEditRow = (r) => {
        printDebugLog("EditIcon,getColums ", r);
        if (disabledOperation) {
            setSnpComponent(prev => ({
                ...prev,
                snackBarOpen: true,
                snackBarMsg: "Cancelled bill cannot be edited",
            }));
            return;
        }
        if (billPayInfo?.paymentInitiated ?? false) {
            setSnpComponent(prev => ({
                ...prev,
                snackBarOpen: true,
                snackBarMsg: "Paid bill cannot be edited",
            }));
            return;
        }
        const item = listBanquetHall?.find(x => String(x.roomId) === String(r.id));
        if (item) {
            setBanquetData(prev => ({
                ...prev,
                ...r
            }));
            setBanquetInformation(prev => ({
                ...prev,
                ...item,
            }));
            setIsEdit(true);
        }
    }



    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Paper
                    elevation={4}
                    autoHeight
                    sx={{
                        borderRadius: 2,
                        p: 2,
                        backgroundColor: "#f7f7e5",
                    }}>

                    <Grid container spacing={2}>
                        {
                            !isEdit && <Grid item xs={12} md={4} sm={6}>
                                <Autocomplete
                                    id="room-select"
                                    options={listBanquetHall}
                                    autoHighlight
                                    variant="filled"
                                    size="small"
                                    fullWidth
                                    onChange={(e, option) => {
                                        if (!canSelectRate) {
                                            setSnpComponent(prev => ({ ...prev, snackBarOpen: true, snackBarMsg: "Please save the Date Selection Form" }));
                                            return;
                                        }
                                        if (option) {
                                            const matchedBookedItem = totalBanquetBookingDetails?.items?.find(booked =>
                                                option.priceList?.some(
                                                    price =>
                                                        String(booked.rateId) === String(price.id) &&
                                                        String(booked.id) === String(price.prdId)
                                                )
                                            );
                                            if (matchedBookedItem) {
                                                setBanquetData(prev => ({
                                                    ...prev,
                                                    ...matchedBookedItem,
                                                }));
                                                setIsEdit(true);
                                            }
                                            setBanquetInformation(prev => ({
                                                ...prev,
                                                ...option,
                                            }));
                                        } else {
                                            setBanquetData(null);
                                            setBanquetInformation(null);
                                        }
                                    }}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    getOptionLabel={(option) => {
                                        if (!option) return "";
                                        return option.name || "";
                                    }}
                                    inputValue={banquetInformation ? banquetInformation.name : ""}
                                    onInputChange={(e, newInput) => {
                                        if (!newInput) setBanquetInformation(null);
                                    }}
                                    value={banquetInformation ?? null}
                                    renderOption={(props, option) => {
                                        const isSelected = totalBanquetBookingDetails?.items?.some(
                                            (item) => String(item.id) === String(option.roomId)
                                        );

                                        return (
                                            <Box
                                                component="li"
                                                {...props}
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "flex-start",
                                                    padding: "6px 12px",
                                                    backgroundColor: isSelected ? "#f9f9f9" : "transparent",
                                                    borderRadius: "6px",
                                                    cursor: "pointer",
                                                    "&:hover": {
                                                        backgroundColor: "#f0f0f0",
                                                    },
                                                }}
                                            >
                                                {/* Option name */}
                                                <span
                                                    style={{
                                                        color: isSelected ? "grey" : "#000",
                                                        fontWeight: isSelected ? "500" : "600",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    {`${option.name}`}
                                                </span>

                                                {/* Show "Already Selected" if matched */}
                                                {isSelected && (
                                                    <span
                                                        style={{
                                                            color: "#1976d2", // MUI blue
                                                            fontSize: "12px",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        Already Selected
                                                    </span>
                                                )}
                                            </Box>
                                        );
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Banquet"
                                            inputProps={{
                                                ...params.inputProps,
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                        }
                        {
                            banquetInformation &&
                            <Grid item xs={12}>
                                <p
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        whiteSpace: "pre-wrap",
                                        overflowWrap: "break-word",
                                        fontFamily: "Arial",
                                        padding: "2px",
                                        margin: 0
                                    }}
                                >
                                    <span
                                        style={{
                                            color: "black",
                                            fontWeight: "bold",
                                            fontSize: "14px"
                                        }}
                                    >
                                        Selected Banquet Hall:{" "}
                                        <span
                                            style={{
                                                color: "#00333e",
                                                fontWeight: "bold",
                                                fontSize: "16px"
                                            }}
                                        >
                                            {banquetInformation?.name || ""}
                                        </span>
                                    </span>

                                    <span
                                        style={{
                                            color: "gray",
                                            fontSize: "14px",
                                            marginTop: "2px"
                                        }}
                                    >
                                        Category:{" "}
                                        <span
                                            style={{
                                                fontSize: "14px"
                                            }}
                                        >
                                            {banquetInformation?.catgName || ""}
                                        </span>
                                    </span>
                                </p>

                            </Grid>
                        }

                        {
                            (banquetInformation && banquetInformation?.priceList) && <Grid item xs={12}>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">Rate Card</FormLabel>
                                    <RadioGroup aria-label="rate-select" name="rate-select" value={banquetData?.rateId ?? null} onChange={(e) => {
                                        if (!canSelectRate) {
                                            setSnpComponent(prev => ({ ...prev, snackBarOpen: true, snackBarMsg: "Please save the Date Selection Form" }));
                                            return;
                                        }

                                        const item = banquetInformation?.priceList?.find(x => String(x.id) === String(e.target.value));
                                        if (!item) return;

                                        const parseAmt = Number(e.target.id) || 0;
                                        setBanquetData(prev => ({
                                            ...prev,
                                            rateId: e.target.value,
                                            sAmt: parseAmt,
                                            rateName: e.target.name,
                                            catgName: banquetInformation?.catgName || "",
                                            banquetName: banquetInformation?.name || "",
                                            banquetNo: banquetInformation?.roomNo || "",
                                            tAmt: parseAmt * totalDaysStay,
                                            id: item.prdId,
                                            type: Number(item.type),
                                        }));

                                    }}>
                                        {banquetInformation?.priceList.map((data) => (
                                            <div>
                                                <FormControlLabel control={
                                                    <Radio
                                                        value={data.id}
                                                        name={data.name}
                                                        id={stayType === StayType.DAILY ? data.sAmt : data.hourlyAmt}
                                                    />}
                                                    label={`${data.name} Price: ${RESYMBOL} ${stayType === StayType.DAILY ? data.sAmt : data.hourlyAmt} / ${stayType === StayType.DAILY ? "day" : "hour"}`} />
                                            </div>
                                        ))}
                                    </RadioGroup>
                                </FormControl>

                            </Grid>
                        }

                    </Grid>

                </Paper>
            </Grid>
            {
                banquetInformation &&
                <Grid item xs={12} md={6} sx={{ display: 'flex', gap: 1, justifyContent: 'center', alignItems: 'center' }}>
                    {
                        isEdit && <Button
                            size="small"
                            variant="outlined"
                            onPointerDown={() => {
                                setBanquetData(null);
                                setBanquetInformation(null);
                                setIsEdit(false);
                            }}
                        >
                            Cancel
                        </Button>
                    }
                    {
                        isEdit && <Button
                            size="small"
                            variant="outlined"
                            disabled={disabledOperation}
                            onPointerDown={() => deleteCurrentBanquet()}
                        >
                            Delete
                        </Button>
                    }
                    <Button
                        size="small"
                        variant="contained"
                        onPointerDown={() => {
                            updateData();
                        }}
                    >
                        Update
                    </Button>
                </Grid>
            }
            <Grid item xs={12}>
                <TableContainer component={Paper} elevation={3} sx={{
                    maxHeight: 300,
                    overflowY: "auto",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
                    border: "none",
                    borderRadius: 2,
                }}
                >
                    <Table aria-label="extra-orders-table">
                        <TableHead>
                            <TableRow sx={{
                                backgroundColor: "#01333e",
                                "& .MuiTableCell-root": {
                                    color: "#fff",
                                    fontWeight: "bold",
                                    fontSize: "0.8rem",
                                    padding: "6px 8px",
                                    borderBottom: "none",
                                },
                            }}>
                                <TableCell align="center">Details</TableCell>
                                <TableCell align="center">{`Price/${stayType === StayType.DAILY ? "day" : "hour"}`}</TableCell>
                                <TableCell align="center">T.Price</TableCell>
                                <TableCell align="center">Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {totalBanquetBookingDetails?.items.length === 0 ? (
                                <TableRow>
                                    <TableCell align="center" colSpan={7}>
                                        <Typography variant="body2" color="text.secondary">
                                            No items yet. Add some above.
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                totalBanquetBookingDetails?.items.map((r) => (
                                    <TableRow key={`${r.id}::${r.rateId}`}>
                                        <TableCell align="center">{`${r.banquetName || ""} ${isEmpty(r.rateName) ? "" : ` (${r.rateName})`}`}</TableCell>
                                        <TableCell align="center">{`${RESYMBOL} ${r.sAmt}`}</TableCell>
                                        <TableCell align="center">{`${RESYMBOL} ${r.tAmt}`}</TableCell>
                                        <TableCell align="center">
                                            <Stack direction="row" spacing={1} justifyContent="center">
                                                <IconButton
                                                    size="small"
                                                    aria-label="edit"
                                                    onPointerDown={() => handleEditRow(r)}
                                                >
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton
                                                    size="small"
                                                    aria-label="delete"
                                                    onPointerDown={() => deleteCurrentBanquet(r)}
                                                >
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </Stack>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
    );
};
export { BanquetForm };